// @flow

import React, { type Element, useState } from 'react'
import NumberFormat from 'react-number-format'
import { TextField } from '@material-ui/core'
import { core } from '../../../lib/WasmCache'
import {
  useValidationResult,
  handleChange,
  handleBlur,
  getErrorMsg,
} from '../../../lib/CoreValidations'

type Props = {|
  phoneNumber: string,
  setPhoneNumber: (string) => void,
  setIsValid: (boolean) => void,
|}

function NumberFormatCustom({ name, inputRef, onChange, ...other }): Element<typeof NumberFormat> {
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        })
      }}
      format="+1 (###) ###-####"
      mask="_"
    />
  )
}

function PhoneNumberField({
  phoneNumber,
  setPhoneNumber,
  setIsValid,
}: Props): Element<typeof TextField> {
  const [validationResult, onChange, onBlur] = useValidationResult(core.validatePhoneNumber)
  const [errorObj, setErrorObj] = useState({ isVisible: false, msg: ' ' })

  return (
    <TextField
      label="Phone number"
      id="phone-number"
      variant="outlined"
      value={phoneNumber}
      onChange={(e) => {
        handleChange(e.target.value, onChange, setIsValid, setPhoneNumber)
        setErrorObj({ isVisible: false, msg: '' })
      }}
      onBlur={(e) => {
        handleBlur(phoneNumber, onBlur, setIsValid)
        setErrorObj({ isVisible: true, msg: getErrorMsg(validationResult) })
      }}
      InputProps={{ inputComponent: NumberFormatCustom }}
      fullWidth
      error={!validationResult.is_success && errorObj.isVisible}
      helperText={
        !validationResult.is_success && errorObj.isVisible
          ? errorObj.msg
          : 'In case we need to contact you during your account setup.'
      }
      required
    />
  )
}

export default PhoneNumberField
